import * as React from 'react';
import { PVAGenericMultiSelect, PVASelect, LoadingIndicator, InclinationChart, PVAContainer, PVANav, PVADiamond, PVAContentHeader, PVACharacteristicGroupModal, PVAContentBody, PVACharacteristicModal, LoadingIndicatorMini } from '../../../components';
import { ReportType } from '../../../enums';
import { ReportDataService, CharacteristicDataService, CharacteristicGroupDataService } from '../../../services';
import { CharacteristicGroup, Characteristic, CharacteristicText, SurveyVersion, CharacteristicGroupCharacteristic } from '../../../models';
import { BaseRouteProps } from '../../../interfaces';
import { UserStore, FilterStore } from '../../../stores';
import { inject, observer } from 'mobx-react';
import { computed } from 'mobx';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface ScoreComparisonState {
    selectedUserData: any[];
    selectedVersionIds: number[];
    reportType: ReportType;
    characteristicGroups: CharacteristicGroup[];
    characteristics: Characteristic[];
    orgId: number;
    teamId: number;
    userId: number;
    surveyId: number;
    surveyVersionId: number;
    surveyVersions: SurveyVersion[];
    selectedUserIds: number[];
    sticky: boolean;
    stickySize: number;
    stickyGroups: number[];
    activeInd: number;    
    groupPos: number[];
    loading: boolean;
    miniLoader: boolean;
    pdfLoader: boolean;
    open: boolean;
}

interface ScoreComparisonProps extends BaseRouteProps<{}> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

@inject('UserStore', 'FilterStore') @observer
export class ScoreComparison extends React.Component<ScoreComparisonProps, ScoreComparisonState> {
    private reportDataService = new ReportDataService(this.props.notificationService);
    private characteristicDataService = new CharacteristicDataService(this.props.notificationService);
    private characteristicGroupDataService = new CharacteristicGroupDataService(this.props.notificationService);
    private banner: any;
    private pageTop: any;
    private groupEls: any[];
    // private scrollUpdate: any | undefined;

    @computed get userRole() {
        return this.props.UserStore!.userInfo.userRole;
    }

    @computed get users() {
        if (this.props.FilterStore && this.props.FilterStore.users) {
            return this.props.FilterStore.users;
        }
        return [];
    }

    @computed get survey() {
        if (this.props.FilterStore && this.props.FilterStore.survey) {
            return this.props.FilterStore.survey;
        }
        return null;
    }

    @computed get surveyVersions() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersions) {
            return this.props.FilterStore.surveyVersions;
        }
        return [];
    }

    @computed get organization() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return this.props.FilterStore.organization;
        }
        return null;
    }

    @computed get team() {
        if (this.props.FilterStore && this.props.FilterStore.team) {
            return this.props.FilterStore.team;
        }
        return null;
    }

    @computed get userPermissions() {
        return this.props.UserStore!.userInfo.userPermissions;
    }

    @computed get surveyReportType() {
        if (this.props.FilterStore && this.props.FilterStore.surveyReportType) {
            return this.props.FilterStore.surveyReportType;
        }
        return null;
    }

    @computed get surveyVersion() {
        var surveyVersionsSorted = this.surveyVersions.sort((sv1: SurveyVersion, sv2: SurveyVersion) => {
            if (sv1.version > sv2.version) {
                return 1;
            }
            if (sv1.version < sv2.version) {
                return -1;
            }
            return 0;
        });

        if (surveyVersionsSorted.length > 0) {
            return surveyVersionsSorted[0];
        }
        return undefined;
    }

    constructor(props: ScoreComparisonProps) {
        super(props);

        this.groupEls = [];
        // this.scrollUpdate = undefined;

        this.state = {
            selectedUserData: [],
            selectedVersionIds: [],
            characteristicGroups: [],
            characteristics: [],
            reportType: ReportType.Standard,
            orgId: 0,
            teamId: 0,
            userId: 0,
            surveyId: 0,
            surveyVersionId: 0,
            surveyVersions: [],
            selectedUserIds: [],
            sticky: false,
            stickySize: 0,
            stickyGroups: [],
            activeInd: -1,
            groupPos: [],
            loading: false,
            miniLoader: false,
            pdfLoader: false,
            open: false
        };
    }

    private update() {
        if (this.team && this.team.id !== this.state.teamId) {
            this.setState({
                teamId: this.team.id,
                selectedUserData: [],
                selectedUserIds: []
            });
        } else if (!this.team && this.state.teamId) {
            this.setState({
                teamId: 0,
                selectedUserData: [],
                selectedUserIds: []
            });
        }

        if (this.survey !== null && this.state.surveyId !== this.survey.id) {
            var survey = this.survey;

            this.setState({
                surveyId: survey.id
            });

            if (this.surveyVersion) {
                var surveyVersion = this.surveyVersion;

                this.setState({
                    surveyVersionId: surveyVersion.id,
                    loading: true
                });
                
                this.characteristicGroupDataService.getAllBySurveyVersion(surveyVersion).then((characteristicGroups: CharacteristicGroup[]) => {
                    var stickyGroups: number[] = [];
                    var groupPos: number[] = [];
                    characteristicGroups = characteristicGroups.filter((cg: CharacteristicGroup) => {
                        if (cg.secondaryReportID) {
                            return false;
                        }
                        return true;
                    });

                    characteristicGroups.map((data: any, ind: number) => {
                        stickyGroups[ind] = 0;
                        groupPos[ind] = 0;
                    });

                    this.setState({
                        characteristicGroups: characteristicGroups,
                        stickyGroups: stickyGroups,
                        groupPos: groupPos
                    });

                    this.characteristicDataService.getAllBySurveyVersion(surveyVersion).then((characteristics: Characteristic[]) => {
                        this.setState({
                            characteristics: characteristics,
                            loading: false
                        });
                    });
                });
            }
        }
    }

    componentDidMount() {
        this.update();
    }

    componentWillReact() {
        this.update();
    }

    updateNav() {
                var stick = this.state.stickySize;
        
                if (this.banner && this.state.stickySize === 0) {
                    this.setState({
                        stickySize: this.banner.offsetTop
                    });
                    stick = this.banner.offsetTop;
                }
        
                var sticky = stick;
        
                if (this.pageTop.scrollTop >= sticky) {
                    this.setState({
                        sticky: true
                    });
                } else {
                    this.setState({
                        sticky: false
                    });
                }
        
                var stickies = this.state.stickyGroups;
                var i: number = 0;
                var activeInd: number = -1;
                if (this.state.sticky) {
                    for (; i < this.groupEls.length; i++) {
                        if (this.groupEls[i]) {
                            this.state.groupPos[i] = this.groupEls[i].offsetTop;
                        }
                        stickies[i] = 0; // white
                        if (this.state.groupPos[i] !== 0) {
                            if (this.pageTop.scrollTop >= this.state.groupPos[i] - 250) {
                                stickies[i] = 1; // active
                                activeInd = i;
                                for (var j: any = 0; j < i; j++) {
                                    stickies[j] = 2; // past
                                }
                            }
                        }
                    }
                } else {
                    for (; i < this.groupEls.length; i++) {
                        stickies[i] = 0;
                    }
                }
                this.setState({
                    stickyGroups: stickies,
                    activeInd: activeInd
                });
        //     },
        //     1
        // );
    }

    handleScroll(event: any, t: any) {
        if (event.target.getAttribute('class') !== 'site-content-inner') {
            return;
        }
        this.updateNav();
    }

    tooltip(c: Characteristic) {
        if (!c.characteristicTexts) {
            return '';
        }

        var result = '';
        c.characteristicTexts.map((ct: CharacteristicText) => {
            if (ct.textType === 'tooltip') {
                result = ct.value;
            }
        });

        return result;
    }

    filteredCharacteristics(groupData: any, characteristic: Characteristic) {
        return groupData.data.filter((x: any) => {
            return x.characteristicID === characteristic.id || x.previousCharacteristicID === characteristic.id;
        });
    }

    private GetKeyOverride(key?: string, fallback?: any) {
        if (key && this.props.FilterStore) {
            return this.props.FilterStore.GetKeyOverride(key, fallback || '');
        }
        return fallback;
    }

    public userChange(e: any, userIdFromQueryString: boolean = false) {
        var userId: number = Number(e.target.value);
        this.setState({
            userId: userId,
            miniLoader: true
        });

        this.props.FilterStore!.individualReportUserId = userId;

        if (this.userRole !== 'user') {
            this.setState(
                {
                    selectedUserData: []
                }, 
                () => {
                    var promises = this.state.selectedVersionIds.map((id: number) => {
                        return new Promise((resolve: any, reject: any) => {
                            var surveyVersion = this.surveyVersions.find((sv: SurveyVersion) => {
                                return sv.id === id;
                            });
                            if (surveyVersion) {
                                this.loadSurveyVersion(surveyVersion, resolve);
                            }
                        });
                    });
                    Promise.all(promises).then(() => {
                        this.setState({
                            miniLoader: false
                        });
                    });
                });
        }
    }

    private unloadSurveyVersion(surveyVersion: SurveyVersion) {
        var data = this.state.selectedUserData;
        var ind = data.findIndex((d: any) => {
            return d.surveyVersionId === surveyVersion.id;
        });
        if (ind > -1) {
            data.splice(ind, 1);
            this.setState({
                selectedUserData: data
            });
        }
    }

    private loadSurveyVersion(surveyVersion: SurveyVersion, cb?: any) {
        if (this.state.userId !== 0 && this.survey) {
            this.setState({
                miniLoader: true
            });
            this.reportDataService.getIndividualReportData(this.survey.id, this.state.userId, surveyVersion.id).then((reportData) => {
                var stickyGroups: number[] = [];
                var groupPos: number[] = [];
                reportData.inclinationGroups.map((d: any, ind: number) => {
                    stickyGroups[ind] = 0;
                    groupPos[ind] = 0;
                });
                var data = this.state.selectedUserData;
                data.push({ 
                    label: '#' + surveyVersion.version + (surveyVersion.nickname ? (' - ' + surveyVersion.nickname) : ''),
                    surveyVersionId: surveyVersion.id, 
                    data: reportData });
                this.setState(
                    {
                        selectedUserData: data,
                        stickyGroups: stickyGroups,
                        groupPos: groupPos,
                        miniLoader: cb !== undefined
                    }, 
                    cb);
            });
        }
    }

    private loadVersion(e: any) {
        var id = parseInt(e.target.value, 10);
        var versions = this.state.selectedVersionIds;
        
        var sv = this.surveyVersions.find((surveyVersion: SurveyVersion) => {
            return surveyVersion.id === id;
        });

        if (sv) {
            var prevInd = versions.indexOf(id);
            if (prevInd > -1) {
                versions.splice(prevInd, 1);
                // unload this version
                this.unloadSurveyVersion(sv);
            } else {
                versions.push(id);
                // load this version
                this.loadSurveyVersion(sv);
            }
        }
        this.setState({
            selectedVersionIds: versions
        });
    }

    public render() {
        // let modals: any[] = [];

        var defaultOptions = [{
            id: 0,
            value: '- Clear Selected -'
        }];

        const surveyVersions = this.surveyVersions.map((x: SurveyVersion) => {
            return {
                id: x.id,
                label: '#' + x.version + (x.nickname ? (' - ' + x.nickname) : '')
            };
        });

        var offset = 0;

        var contentHeaderSmall = (
            <div className="row">
                <div className="col-sm-6 col-md-8 col-xs-12">
                    <div className="title">
                        {this.GetKeyOverride('comparisonReport', <span>PVA Score Comparison<span className="trademark">TM</span></span>)}
                         <span className="light"> for </span>
                         <PVASelect defaultOptions={defaultOptions} options={this.users} selected={this.state.userId} onChange={(e: any) => this.userChange(e)} />
                        <PVAGenericMultiSelect options={surveyVersions} selected={this.state.selectedVersionIds} onChange={(e: any) => { this.loadVersion(e); }} />
                        {this.team && <span><span className="light"> in </span>'{this.team.name}'</span>}
                        {this.state.miniLoader && <LoadingIndicatorMini />}
                    </div>
                </div>
                <div className="col-sm-6 col-md-4 text-right" />
            </div>
        );
        
        return (
            <div className="site-content-inner" ref={(e) => this.pageTop = e} onScroll={(e) => this.handleScroll(e, this)}>
                {this.organization && <div id={`organization-${this.organization.id}`} />}
                {this.survey && <div id={`survey-${this.survey.id}`} />}
                {this.surveyVersion && <div id={`surveyVersion-${this.surveyVersion.id}`} />}
                {this.surveyReportType && <div id={`surveyReportType-${this.surveyReportType.id}`} />}

                <PVAContentHeader>
                    <div className="row">
                        <div className="col-sm-10 col-md-8 col-xs-12">
                            <div className="title">
                                {this.GetKeyOverride('comparisonReport', <span>PVA Score Comparison <span className="trademark">TM</span></span>)} <span className="light"> for </span>
                                {!this.state.sticky && <PVASelect defaultOptions={defaultOptions} options={this.users} selected={this.state.userId} onChange={(e: any) => this.userChange(e)} />}
                                <PVAGenericMultiSelect options={surveyVersions} selected={this.state.selectedVersionIds} onChange={(e: any) => { this.loadVersion(e); }} />
                                {/* <PVAMultiSelect options={this.users} selected={this.state.selectedUserIds} onChange={(e: any) => this.toggleUserSelect(e)} FilterStore={this.props.FilterStore} /> */}
                                {this.team && <span><span className="light"> in </span>'{this.team.name}'</span>}
                                {this.state.miniLoader && <LoadingIndicatorMini />}
                            </div>
                        </div>
                        <div className="col-sm-2 col-md-4 text-right" />
                    </div>
                </PVAContentHeader>

                <div ref={(e) => this.banner = e}>
                    {this.state.selectedUserData && <PVANav requireCharacteristics={true} FilterStore={this.props.FilterStore} content={contentHeaderSmall} activeInd={this.state.activeInd} groups={this.state.characteristicGroups} stickyGroups={this.state.stickyGroups} sticky={this.state.sticky} onSelect={(e: any) => this.updateNav()}  />}
                </div>

                {this.state.loading && <PVAContentBody><LoadingIndicator /></PVAContentBody>}
                {this.state.pdfLoader && <PVAContentBody><LoadingIndicator showPdfDescription={true} showBackground={true} showInPanel={true}/></PVAContentBody>}
                {!this.state.loading && !this.state.pdfLoader && <PVAContentBody>
                    {this.state.characteristicGroups.filter((x: any) => {
                        if (!this.surveyReportType) {
                            return true;
                        }
                        return x.surveyReportTypeID === this.surveyReportType.id;
                    }).map((group: CharacteristicGroup, groupInd: number) => {
                        var off = offset;
                        offset += this.state.characteristics.filter((x: Characteristic) => {
                            return x.characteristicGroupID === group.id;
                        }).length;

                        const icon = <PVADiamond step={groupInd + 1} />;
                        const title = <div>
                                <div className="title-sub">{group.subtitle}</div>
                                <span> {group.name}
                                    &nbsp;&nbsp;
                                    <span onClick={this.toggleGroupModal.bind(this, groupInd)} className="glyphicon glyphicon-info-sign icon-button" />
                                </span>
                            </div>;
                            
                        const content = (
                            <div>
                                <div className="inclination-table comparison">

                                    <div className="row">
                                        <div className="col-xs-6 col-md-5 col-lg-4">
                                            <div className="cell" />
                                            {
                                                this.state.characteristics.filter((x: Characteristic) => {
                                                    var g = x.characteristicGroupCharacteristics.find((cgc: CharacteristicGroupCharacteristic) => {
                                                        return cgc.characteristicGroupID === group.id;
                                                    });
                                                    if (g) {
                                                        return true;
                                                    }
                                                    return x.characteristicGroupID === group.id;
                                                }).sort((c1: Characteristic, c2: Characteristic) => {
                                                    var sort1 = c1.sort;
                                                    var sort2 = c2.sort;
                                            
                                                    var cgc1 = c1.characteristicGroupCharacteristics.find((c: CharacteristicGroupCharacteristic) => {
                                                        return c.characteristicGroupID === group.id;
                                                    });
                                                    var cgc2 = c2.characteristicGroupCharacteristics.find((c: CharacteristicGroupCharacteristic) => {
                                                        return c.characteristicGroupID === group.id;
                                                    });
                                                    if (cgc1) {
                                                        sort1 = cgc1.sort;
                                                    }
                                                    if (cgc2) {
                                                        sort2 = cgc2.sort;
                                                    }
                                            
                                                    if (sort1 > sort2) {
                                                        return 1;
                                                    } else if (sort1 < sort2) {
                                                        return -1;
                                                    }
                                                    return 0;
                                                }).map((characteristic: Characteristic, charIndex: number) => {

                                                    var propCharContent = '';
                                                    var propCharValue = '';
                                                    var showCharModal = false;
                                                    if (characteristic.characteristicTexts && characteristic.characteristicTexts.length > 0) {
                                                        showCharModal = characteristic.characteristicTexts[0].showModal;
                                                        propCharContent = this.getText(characteristic.characteristicTexts, 'tooltip');
                                                        propCharValue = this.getText(characteristic.characteristicTexts, 'higH_TEXT');
                                                    }

                                                    const propsChar = {
                                                        show: showCharModal,
                                                        onHide: this.toggleModal.bind(this, characteristic),
                                                        title: group.name,
                                                        content: propCharContent,
                                                        value: undefined,
                                                        description: propCharValue,
                                                        core: group.subtitle,
                                                        step: groupInd + 1,
                                                        name: characteristic.name,
                                                        allowToggle: this.userPermissions.indexOf('scoreBarColorChange') > -1
                                                    };

                                                    const tooltip = <Tooltip id={`char-tooltip-${charIndex}`}><span dangerouslySetInnerHTML={{ __html: this.tooltip(characteristic) }} /></Tooltip>;
                                                    return <div className="text-left" key={`grid-cell-${charIndex}`}>
                                                                <div className="cell">
                                                                    <OverlayTrigger animation={''} delay={0} placement="top" overlay={tooltip}>
                                                                        <div className="grid-cell-title" onClick={this.toggleModal.bind(this, characteristic)}>
                                                                            <span className="characteristic-index">{off + charIndex + 1} </span>
                                                                            <span className="characteristic-info glyphicon glyphicon-info-sign icon-button" />
                                                                            <span className="characteristic-title">
                                                                                    <b>{characteristic.name}</b>
                                                                            </span>
                                                                        </div>
                                                                    </OverlayTrigger>
                                                                
                                                                <PVACharacteristicModal {...propsChar} />
                                                            </div>
                                                            
                                                            {
                                                                this.state.selectedUserData.map((userData: any, userInd: number) => {
                                                                    return <div key={`grid-cell-user-${userInd}`} className="cell grid-cell-user">
                                                                        <span>{userData.label}</span>
                                                                    </div>;
                                                                })
                                                            }
                                                        </div>;
                                                })
                                            }
                                        </div>
                                        <div className="col-xs-6 col-md-7 col-lg-8">
                                            <div className="bg" />
                                            <div className="cell">
                                                <div className="row">
                                                    <div className="col-xs-6 text-left">
                                                        <div className="cell">
                                                            <span className="chart-content" style={{ left: -5 }}>Less Pronounced</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-6 text-right">
                                                        <div className="cell">
                                                            <span className="chart-content" style={{ right: 0 }}>More Pronounced</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.characteristics.filter((x: Characteristic) => {
                                                var g = x.characteristicGroupCharacteristics.find((cgc: CharacteristicGroupCharacteristic) => {
                                                    return cgc.characteristicGroupID === group.id;
                                                });
                                                if (g) {
                                                    return true;
                                                }
                                                return x.characteristicGroupID === group.id;
                                            }).sort((c1: Characteristic, c2: Characteristic) => {
                                                var sort1 = c1.sort;
                                                var sort2 = c2.sort;
                                        
                                                var cgc1 = c1.characteristicGroupCharacteristics.find((c: CharacteristicGroupCharacteristic) => {
                                                    return c.characteristicGroupID === group.id;
                                                });
                                                var cgc2 = c2.characteristicGroupCharacteristics.find((c: CharacteristicGroupCharacteristic) => {
                                                    return c.characteristicGroupID === group.id;
                                                });
                                                if (cgc1) {
                                                    sort1 = cgc1.sort;
                                                }
                                                if (cgc2) {
                                                    sort2 = cgc2.sort;
                                                }
                                        
                                                if (sort1 > sort2) {
                                                    return 1;
                                                } else if (sort1 < sort2) {
                                                    return -1;
                                                }
                                                return 0;
                                            }).map((characteristic: Characteristic) => {
                                                return <div key={characteristic.id}>
                                                    <div className="cell" />
                                                    <div className="comparison-bg">
                                                        {
                                                            this.state.selectedUserData.map((userData: any, userDataIndex: number) => {
                                                                var allowToggle = this.userPermissions.indexOf('scoreBarColorChange') > -1;

                                                                if (userData.data.inclinationGroups.length === 0) {
                                                                    return (<div className="cell" key={`grid-chart-empty-${userDataIndex}`}>
                                                                        <InclinationChart value={0} allowToggle={allowToggle} />
                                                                    </div>);
                                                                }

                                                                return userData.data.inclinationGroups.filter((x: any) => {
                                                                    return x.characteristicGroupID === group.id || x.prevCharacteristicGroupID === group.id;
                                                                }).map((groupData: any, ind: any) => {
                                                                    const elements = this.filteredCharacteristics(groupData, characteristic).map((item: any, index: number) => {
                                                                        return (<div className="cell" key={`grid-chart-${index}`}>
                                                                            <InclinationChart value={item.value} allowToggle={allowToggle} />
                                                                        </div>);
                                                                    });
                                                                    return elements;
                                                                });
                                                            })
                                                        }
                                                    </div>
                                                </div>;
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );

                        var propName = '';
                        var propContent = '';
                        var showModal = false;
                        if (group.characteristicGroupTexts && group.characteristicGroupTexts.length > 0) {
                            showModal = group.characteristicGroupTexts[0].showModal;
                            propName = group.name;
                            propContent = group.characteristicGroupTexts[0].value;
                        }

                        const props = {
                            show: showModal,
                            onHide: this.toggleGroupModal.bind(this, groupInd),
                            title: propName,
                            content: propContent,
                            core: group.subtitle,
                            step: groupInd + 1
                        };

                        return (
                            <div key={`group-${groupInd}`} ref={(e) => this.groupEls[groupInd] = e}>
                                <PVAContainer icon={icon} title={title} content={content} id={group.name} />
                                <PVACharacteristicGroupModal {...props} />
                            </div>);
                    })}
                </PVAContentBody>}
            </div>);
    }

    toggleGroupModal(ind: number) {
        if (this.state.characteristicGroups[ind] && this.state.characteristicGroups[ind].characteristicGroupTexts && this.state.characteristicGroups[ind].characteristicGroupTexts.length > 0) {
            this.state.characteristicGroups[ind].characteristicGroupTexts[0].showModal = !this.state.characteristicGroups[ind].characteristicGroupTexts[0].showModal;
            this.forceUpdate();
        }
    }

    toggleModal(c: Characteristic) {
        if (c && c.characteristicTexts && c.characteristicTexts.length > 0) {
            c.characteristicTexts[0].showModal = !c.characteristicTexts[0].showModal;
            this.forceUpdate();
        }
    }

    getText(characteristicTexts: CharacteristicText[], key: string) {
        var charText = characteristicTexts.find((ct: CharacteristicText) => {
            return ct.textType === key;
        });
        if (charText) {
            return charText.value;
        }
        return '';
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/scoreComparison/ScoreComparison.tsx